import type { NextPage } from "next";
import ErrorView from "@/views/errors/errorView";

const PageNotFound: NextPage = () => {
  return (
    <ErrorView
      title="404 - Page Not Found"
      authDescription="The page you are looking for does not exist. Please report the issue if you feel this is an error."
      noAuthDescription="The page you are looking for does not exist."
    />
  );
};

PageNotFound.showNavigation = true;

export default PageNotFound;
